"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLocale = parseLocale;
var includes_1 = __importDefault(require("lodash/fp/includes"));
var flow_1 = __importDefault(require("lodash/fp/flow"));
var find_1 = __importDefault(require("lodash/fp/find"));
var toLower_1 = __importDefault(require("lodash/fp/toLower"));
var replace_1 = __importDefault(require("lodash/fp/replace"));
var eq_1 = __importDefault(require("lodash/fp/eq"));
var locales_1 = __importDefault(require("./locales"));
function parseLocale(locale, option) {
    var target;
    var normalized = (0, flow_1.default)(toLower_1.default, (0, replace_1.default)('-', '_'))(locale);
    if ((0, includes_1.default)('_')(locale)) {
        target = (0, find_1.default)((0, flow_1.default)(toLower_1.default, (0, eq_1.default)(normalized)))(locales_1.default);
    }
    else {
        target = (0, find_1.default)((0, flow_1.default)(toLower_1.default, (0, includes_1.default)(normalized)))(locales_1.default);
    }
    return target || (option === null || option === void 0 ? void 0 : option.fallback);
}
exports.default = parseLocale;
